import { render } from "./SessionListItem.vue?vue&type=template&id=abb17a7a&scoped=true"
import script from "./SessionListItem.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./SessionListItem.vue?vue&type=script&charset=utf-8&lang=js"

import "./SessionListItem.vue?vue&type=style&index=0&id=abb17a7a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abb17a7a"]])

export default __exports__